import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=ef386048&scoped=true"
import script from "./normal.vue?vue&type=script&lang=js"
export * from "./normal.vue?vue&type=script&lang=js"
import style0 from "./normal.vue?vue&type=style&index=0&id=ef386048&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef386048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef386048')) {
      api.createRecord('ef386048', component.options)
    } else {
      api.reload('ef386048', component.options)
    }
    module.hot.accept("./normal.vue?vue&type=template&id=ef386048&scoped=true", function () {
      api.rerender('ef386048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/normal.vue"
export default component.exports